// ✅ Put this at the top or in a separate file (mockData.ts)
export const mockCompanyData = {
  "Relevance": "Yes, it is relevant",
  "Key Area": "Post-production (editing, sound design, title creation, commercial editing)",
  "Company 1": {
    "Company Name": "Truly Visual Post",
    "Also Known As": ["TVP"],
    "Company Description": "Truly Visual Post is a post-production company led by Adam Heayberd, specializing in film, television, sports, documentary, and branded content editing.",
    "Company Type": "Post-Production House",
    "Services Offered": [
      "Editing",
      "Post-production",
      "Sound design",
      "Title creation",
      "Commercial editing"
    ],
    "Location Headquarters": "Not specified",
    "Other Offices": [
    "Mumbai, India",
    "Hyderabad, India"
],
    "Team Size": "Independent / Freelance",
    "Founding Year": "Not specified",
    "Parent Company": "Independent",
    "Leadership Contacts": [
      {
        "Name": "Adam Heayberd",
        "Designation": "Editor / Founder",
        "Email": "Not specified",
        "LinkedIn Url": "Not specified"
      }
    ],
    "Social Links": {
      "LinkedIn": "Not specified",
      "Facebook": "Not specified",
      "Instagram": "Not specified",
      "Twitter": "Not specified"
    },
    "Website": "https://www.trulyvisualpost.com/truly-visual-post",
   
    "Logo Url": "https://static.wixstatic.com/media/9f1d8a_2d3bce8f0bb04f93a7e43f0e3f2c0432~mv2.png",
    "Contact Details": {
      "Email": "Not specified",
      "Phone": "Not specified"
    },
    "Clients Or Projects": [
      "BBC - Great Indian Cricket Dream",
      "BBC - Helen Glover Documentary",
      "Sky Sports F1 with Hans Zimmer",
      "Sky Sports NFL Super Bowl",
      "UNICEF (Commercial with Liam Neeson)",
      "Nokia Commercial",
      "Autofabrica Commercial",
      "Esports World Cup (BBC, CNN, Eurosport)",
      "Ireland’s Tracks & Trails (RTE)",
      "The Road to Tokyo Documentary"
    ],
    "Keywords": [
      "Post-production",
      "Editing",
      "Film",
      "Documentary",
      "Commercials",
      "Broadcast",
      "Sport",
      "Branded content"
    ],
     "Compliance_and_Operational_Data": {
      "Security Practices": "The best available hardware, including next-gen firewalls with advanced Layer 7 protection, is used to deploy updates and manage your firewalls. Furthermore, constant monitoring and hourly backups of your firewall configurations, along with a complete revision history, are provided as part of our fully-managed firewall service.",
      "DE&I": "The company follows the DE&I standards set by the industry.",
      "Environment Sustainability Goals": "The company is aligned with the BAFTA Albert standard for sustainability and reducing carbon emissions.",
      "Tax Credits/Incentives": "No benefits from tax rebates or tax credit schemes.",
      "Commercial Model/Rate Card": "Not Available"
    }
  }
};
